import { Capabilities } from '@sharefiledev/sfplugin-capability-contracts';
import { DefaultRequestListDataProvider } from '../PluginDataProvider/DefaultRequestListDataProvider';
import { ItemDetailsTabQueryParam } from '../TasksView/DetailsPane/useItemDetailTabNavigation';
import { TaskQueryParamName } from '../TasksView/useViewedItem';
import { getItemRID } from './getItemRID';
import { getRequestListRID } from './getRequestListRID';

export const itemCapabilities: Capabilities = {
	async getNavigationDetails(requestedByResourceId, options = {}) {
		const requestListRID = getRequestListRID(requestedByResourceId);
		const itemRID = getItemRID(requestedByResourceId);
		const navigationDetails = await DefaultRequestListDataProvider.getTask(
			requestListRID.entityId,
			requestListRID.toString(),
			itemRID.entityId
		);
		const searchParams = new URLSearchParams();
		searchParams.set(TaskQueryParamName, navigationDetails.requestListTaskId);

		if (options.targetExtensionSlotId) {
			searchParams.set(ItemDetailsTabQueryParam, options.targetExtensionSlotId);
		}

		return {
			name: navigationDetails.title,
			webAppPath: `/requestlists/${
				navigationDetails.requestListId
			}?${searchParams.toString()}`,
		};
	},
};
